export const isUserNameValid = (username: string) => {
  const res = /^[a-z0-9]+$/.exec(username);
  return res?.length ? true : false;
};

export const isGroupNameValid = (groupName: string) => {
  return /^[a-z-]+$/.test(groupName);
};
